import axios from 'axios';
import { getAccessToken } from '@/auth';

const instance = axios.create({
  baseURL: process.env.VUE_APP_AXIOS_BASE_URL,
});

instance.interceptors.request.use(
  async (config) => {
    const accessToken = await getAccessToken();
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
  },
  (error) => Promise.reject(error),
);

export default instance;
